import Container from 'typedi'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import RegisterService from '../services/register.service'
import GtrStorage from '../services/storage.service'

@Module({
    namespaced: true
})
export default class RegisterStore extends VuexModule {
    allContent: any[] = []
    a2zData: any = {}

    @Mutation
    SET_ALL_CONTENT (payload: any) {
        this.allContent = payload
    }

    @Mutation
    SET_A2Z_DATA (payload: any) {
        this.a2zData = payload
    }

    @Action({ rawError: true })
    async createGroupRegistration(payload: any) {
        const { event_identifier } = payload
        const response = await Container.get(RegisterService).createGroupRegistration(event_identifier)
        Container.get(GtrStorage).setItem(`${event_identifier}_group_uuid`, response.data.uuid)
        const data: any = {
            event_identifier,
            group_uuid: response.data.uuid,
        }
        await this.context.dispatch('addToGroupRegistration', data)
        return response
    }

    @Action({ rawError: true })
    async addToGroupRegistration (payload: any) {
        const  { event_identifier, group_uuid} = payload
        return await Container.get(RegisterService).addToGroupRegistration(event_identifier, group_uuid)
    }

    @Action({ rawError: true })
    async addA2ZToGroup (payload: any) {
        const  { event_identifier, group_uuid} = payload
        return await Container.get(RegisterService).addToA2ZGroupRegistration(event_identifier, group_uuid)
    }

    @Action({ rawError: true })
    async addA2ZAlottedBadgeAdhoc (payload: any) {
        const  { event_identifier, group_uuid} = payload
        return await Container.get(RegisterService).addA2ZAlottedBadgeAdhoc(event_identifier, group_uuid)
    }

    @Action({ rawError: true })
    async getA2zData (payload: any) {
        const { event_identifier, group_uuid} = payload
        const response = await Container.get(RegisterService).getA2zData(event_identifier, group_uuid)
        this.context.commit('SET_A2Z_DATA', response.data)
        return response
    }

    @Action({ rawError: true })
    async deleteA2ZGroupRegistration (payload: any) {
        const  { event_identifier, group_uuid, data} = payload
        return await Container.get(RegisterService).deleteA2ZGroupRegistration(event_identifier, group_uuid, data)
    }

    @Action({ rawError: true })
    async deleteGroupParticipantRegistrationSafe (payload: any) {
        return await Container.get(RegisterService).deleteGroupParticipantRegistrationSafe(payload)
    }

    @Action({ rawError: true })
    public async getAllContent (payload: any) {
        const  { event_identifier, reg_type } = payload
        const response = await Container.get(RegisterService).getAllContent(event_identifier, reg_type)
        if (response.data) {
            for (const optionGroupIndex in response.data.option_groups) {
                const optionGroup = response.data.option_groups[optionGroupIndex]
                for (const optionIndex in optionGroup.options) {
                    const option = optionGroup.options[optionIndex]
                    option.option_group = optionGroup // needed for isOptionAtCap, yes its weird but this is how the backend api used to send it back
                }
            }
        }
        this.context.commit('SET_ALL_CONTENT', response)
        return response
    }

    @Action({ rawError: true })
    async deleteParticipantFromGroup (payload: any) {
        const { event_uuid, group_uuid, participant_uuid } = payload
        return await Container.get(RegisterService).deleteParticipantFromGroup(event_uuid, group_uuid, participant_uuid)
    }

    @Action({ rawError: true })
    public async cancelRegistration(payload: { event_identifier: string; token: string }) {
        const { event_identifier, token } = payload
        return await Container.get(RegisterService).cancelRegistration(event_identifier, token)
    }

    @Action({ rawError: true })
    public async idpStart(payload: { event_identifier: string; data: any }) {
        const { event_identifier, data } = payload
        return await Container.get(RegisterService).idpStart(event_identifier, data)
    }

    @Action({ rawError: true })
    public async idpReturnData(payload: { event_identifier: string; data: any }) {
        const { event_identifier, data } = payload
        return await Container.get(RegisterService).idpReturnData(event_identifier, data)
    }


    @Action({ rawError: true })
    public async idpChoose(payload: { event_identifier: string; data: any }) {
        const { event_identifier, data } = payload
        return await Container.get(RegisterService).idpChoose(event_identifier, data)
    }
}
